// extracted by mini-css-extract-plugin
export default {"title":"Ili3pEHrfQ9UrndYg6Q6"};